/*eslint-disable react/no-set-state */
import React from 'react'
import {createFragmentContainer, graphql} from 'react-relay'
import IconButton from 'material-ui/IconButton'
import ModeEdit from '../icons/ModeEdit'
import Delete from '../icons/Delete'
import PropTypes from 'prop-types'
import { ConfirmDialog } from '../common'

class VisibilityBoardRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDeleteMode: false
    }
  }

  handleConfirmDeleteBoard = () => {
    this.props.onDelete(this.props.rowData)
    this.setState({isDeleteMode: false})
  }

  handleCancelDeleteBoard = () => {
    this.setState({isDeleteMode: false})
  }

  render() {
    const { rowData, onEdit, onDelete, departmentMap } = this.props
    const {
      name,
      description,
      boardTemplate,
      footer,
      scrollDuration,
      timeHeaderFormat,
      locationStatusesDisplay,
      departmentExchangeName,
      bedExchangeNames,
    } = rowData

    const locationStatusesDisplayCapitalized = ((str) => {
      return str.charAt(0) + str.substring(1).toLowerCase()
    })(locationStatusesDisplay)

    const rowStyle = {
    border: "1px rgb(224, 224, 224)",
    }

    const columnStyle = {
      border: "1px solid rgb(224, 224, 224)",
      paddingLeft: "15px",
      paddingRight: "15px"
    }

    const ellipsisDiv = {
      width: "150px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }

    return (
      <React.Fragment>
        <tr style={rowStyle}>
          <td style={columnStyle} bgcolor="white">
            <IconButton onClick={() => onEdit(rowData)}>
              <ModeEdit/>
            </IconButton>
          </td>
          <td style={columnStyle} bgcolor="white">{name}</td>
          <td style={columnStyle} bgcolor="white">{description}</td>
          <td style={columnStyle} bgcolor="white">{boardTemplate.name}</td>
          <td style={columnStyle} bgcolor="white">{footer}</td>
          <td style={columnStyle} bgcolor="white">{scrollDuration}</td>
          <td style={columnStyle} bgcolor="white">{timeHeaderFormat}</td>
          <td style={columnStyle} bgcolor="white">{locationStatusesDisplayCapitalized}</td>
          <td style={columnStyle} bgcolor="white">{departmentMap[departmentExchangeName]}</td>
          <td style={columnStyle} bgcolor="white">{bedExchangeNames.length}</td>
          <td style={columnStyle} bgcolor="white">
            <IconButton onClick={() => this.setState({isDeleteMode: true})}>
              <Delete/>
            </IconButton>
          </td>
        </tr>
        { this.state.isDeleteMode !== false &&
          <ConfirmDialog
            open={this.state.isDeleteMode !== false}
            title={`Delete Visibility Board: ${ name }`}
            confirmText="Delete"
            cancelText="Cancel"
            message="The above Visibility Board will be deleted and this action cannot be undone."
            onCancelClick={this.handleCancelDeleteBoard}
            onConfirmClick={this.handleConfirmDeleteBoard}
          />
        }
      </React.Fragment>
    )
  }
}

VisibilityBoardRow.propTypes = {
  rowData: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  departmentMap: PropTypes.object
}

export default createFragmentContainer(VisibilityBoardRow, {
 rowData: graphql`
    fragment VisibilityBoardRow_rowData on VisibilityBoard {
      id
      name
      description
      boardTemplate {
        id
        name
      }
      departmentExchangeName
      bedExchangeNames
      footer
      scrollDuration
      timeHeaderFormat
      locationStatusesDisplay
    }
  `,
})
